import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './TermsPage.css';

function TermsPage() {
  return (
    <div className="terms-page">
      <Header />
      <div className="terms-container">
        <h1>Terms of Service</h1>
        
        <p>
          The following is a legal agreement between you and the owners and operators of FreeFilesDownload.com. By using this Website You agree to be bound by these Terms. This agreement may be revised or updated without notice.
        </p>

        <h2>Downloading and using resource</h2>
        <ul>
          <li>Designer resources are provided free of charge and under the licence they want.</li>
          <li>You agree never to advertise the resource as your own work or portray yourself as the author of said work.</li>
          <li>FreeFilesDownload.com cannot be held responsible for any copyright violations, and cannot guarantee the legality of the resource stored in our system. If You want to make sure, always contact the author. You use the site and the resource at your own risk!</li>
        </ul>

        <h2>Uploading resource</h2>
        <ul>
          <li>You may upload resource to the Website, and FreeFilesDownload.com will screen these uploads to see and downloadable if they are suitable for distribution.</li>
          <li>By uploading, You own the rights to release the resource.</li>
          <li>FreeFilesDownload.com does not allow the upload of Images that infringe on any copyright, property right, trademark or any other applicable right.</li>
          <li>Even though We do our best to prevent infringe happening, FreeFilesDownload.com cannot be held responsible for the misuse or abuse of any resource.</li>
          <li>We also reserve the right to remove any resource at any time if We believe it's defective, of poor quality or infringe on any right.</li>
        </ul>
      </div>
      <Footer />
    </div>
  );
}

export default TermsPage;
